webpackJsonp([133979701655527],{

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _emotion = __webpack_require__(12);
	
	var _emotion2 = _interopRequireDefault(_emotion);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChapterContainer = /*#__PURE__*/(0, _reactEmotion2.default)('li', {
	    target: 'css-16baa7b0'
	})('& h2{margin-bottom:.5rem;}& button{display:flex;border:0 none;background-color:transparent;padding:5px;width:100%;justify-content:center;align-items:center;& i{font-size:.65em;margin-left:3rem;}&:hover{background:#f4f4f4;border-radius:10px;}&:focus{outline:none;}}border-bottom:1px dashed #ccc;padding:20px;&:last-child{border-bottom:0 none;}& div{font-size:.9rem;}& p{margin-bottom:.65rem;}');
	
	var PageListItem = /*#__PURE__*/(0, _reactEmotion2.default)('li', {
	    target: 'css-16baa7b1'
	})('& a{text-decoration:none;color:#222;& i{font-size:.65em;margin-left:5px;}}');
	
	var ChapterDisplay = function (_PureComponent) {
	    _inherits(ChapterDisplay, _PureComponent);
	
	    function ChapterDisplay(props) {
	        _classCallCheck(this, ChapterDisplay);
	
	        var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	        _this.handleOpen = function () {
	            _this.setState({ open: !_this.state.open });
	        };
	
	        _this.state = {
	            open: false
	        };
	        return _this;
	    }
	
	    ChapterDisplay.prototype.render = function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	            ChapterContainer,
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                _react2.default.createElement(
	                    'button',
	                    { onClick: this.handleOpen },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        (this.props.chapter.chapterNumber < 999999999 ? 'Chapter ' + this.props.chapter.chapterNumber + ':' : "") + ' ' + this.props.chapter.title
	                    ),
	                    ' ',
	                    this.state.open ? _react2.default.createElement('i', { className: 'icon-279' }) : _react2.default.createElement('i', { className: 'icon-278' })
	                )
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.props.chapter.subtitle.childMarkdownRemark.html } }),
	            this.state.open ? _react2.default.createElement(
	                'ul',
	                null,
	                this.props.chapter.page.sort(function (a, b) {
	                    return a.pageNumber - b.pageNumber;
	                }).map(function (page) {
	                    return _react2.default.createElement(
	                        PageListItem,
	                        { key: page.id },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/' + _this2.props.chapter.slug + '/' + page.path },
	                            (page.pageNumber < 1000000000 ? 'Page ' + page.pageNumber + '.' : "") + ' ' + page.title,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'icon-276' })
	                        )
	                    );
	                })
	            ) : null
	        );
	    };
	
	    return ChapterDisplay;
	}(_react.PureComponent);
	
	exports.default = ChapterDisplay;
	module.exports = exports['default'];

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(12);
	
	var _emotion2 = _interopRequireDefault(_emotion);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterContainer = /*#__PURE__*/(0, _reactEmotion2.default)('footer', {
	    target: 'css-1o2sc7u0'
	})('background:', function (props) {
	    return !props.chapter ? "#222" : "transparent";
	}, ';color:#e3cf34;text-align:center;');
	
	var Footer = function Footer(props) {
	    return _react2.default.createElement(
	        FooterContainer,
	        { chapter: props.chapter },
	        _react2.default.createElement(
	            'div',
	            {
	                className: (0, _emotion.css)({
	                    margin: '0 auto',
	                    padding: '.5rem 0'
	                })
	            },
	            '\xA9 ',
	            new Date().getFullYear(),
	            ' Hitchhiker\'s Guide to Javascript'
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(12);
	
	var _emotion2 = _interopRequireDefault(_emotion);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderContainer = /*#__PURE__*/(0, _reactEmotion2.default)('header', {
	  target: 'css-1w2lc560'
	})('background:', function (props) {
	  return !props.chapter ? "#222" : "transparent";
	}, ';color:#e3cf34;& h1{margin:0;text-transform:uppercase;font-size:17px;& span{color:#fff;margin-left:20px;}& i{font-size:40px;}}@media (min-width:768px){& h1{font-size:24px;}}');
	
	var Header = function Header(props) {
	  return _react2.default.createElement(
	    HeaderContainer,
	    props,
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _emotion.css)({
	          margin: '0 auto',
	          padding: '1.05rem 1.0875rem'
	        })
	      },
	      _react2.default.createElement(
	        'h1',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/',
	            className: (0, _emotion.css)({
	              color: "#e3cf34",
	              textDecoration: 'none',
	              fontFamily: "'Sonsie One', cursive",
	              display: "flex",
	              alignItems: "center"
	            })
	          },
	          _react2.default.createElement('i', { className: 'icon-211' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'The Hitchhiker\'s Guide to Javascript'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(4);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageContainer = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "css-g1bkpc0"
	})("flex-grow:1;display:flex;flex-direction:column;justify-content:", function (props) {
	  return props.justify ? props.justify : "center";
	}, ";align-content:center;position:relative;");
	
	exports.default = PageContainer;
	module.exports = exports["default"];

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(4);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageTitle = /*#__PURE__*/(0, _reactEmotion2.default)("h1", {
	  target: "css-1fxlrpp0"
	})("color:#ffffff;text-align:center;font-size:28px;font-family:'Sonsie One',cursive;@media (min-width:768px){&{font-size:41px;}}");
	
	exports.default = PageTitle;
	module.exports = exports["default"];

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _ChapterDisplay = __webpack_require__(163);
	
	var _ChapterDisplay2 = _interopRequireDefault(_ChapterDisplay);
	
	var _PageContainer = __webpack_require__(35);
	
	var _PageContainer2 = _interopRequireDefault(_PageContainer);
	
	var _PageTitle = __webpack_require__(36);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	var _Header = __webpack_require__(60);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(34);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageBody = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'css-18slfp70'
	})('padding:20px;flex-grow:1;& ul{list-style-type:none;margin-left:0;}');
	
	var ToCPage = function ToCPage(props) {
	  return _react2.default.createElement(
	    _PageContainer2.default,
	    { justify: 'flex-start' },
	    _react2.default.createElement(_Header2.default, { background: '#222' }),
	    _react2.default.createElement(
	      PageBody,
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Table of Contents'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        props.data.chapters ? props.data.chapters.edges.map(function (chapter) {
	          return _react2.default.createElement(_ChapterDisplay2.default, { key: chapter.node.id, chapter: chapter.node });
	        }) : null
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { background: '#222' })
	  );
	};
	
	exports.default = ToCPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-table-of-contents-js-196db89873f5a2f018b0.js